import { getToken } from '@/lib/auth';

import { client } from './gen/.kubb/client';

client.setConfig({
    auth: async () => (await getToken()) ?? undefined,
});
